/* BeadznThreadz — product quick view (loaded by card-product; safe to include multiple times). */
(function () {
  if (window.BZQuickView) return;

  const cache = new Map();
  let modal;
  let body;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'bz-drawer bz-drawer--center bz-qv-modal';
    modal.id = 'BzQuickView';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick view');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="bz-drawer__overlay" data-bz-close></div>' +
      '<div class="bz-drawer__panel">' +
      '<button type="button" class="bz-close bz-qv-modal__close" data-bz-close aria-label="Close">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m2.5 2.5 11 11m0-11-11 11" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>' +
      '</button><div class="bz-drawer__body bz-qv-modal__body"></div></div>';
    document.body.appendChild(modal);
    body = modal.querySelector('.bz-qv-modal__body');
  }

  function skeleton() {
    return (
      '<div class="bz-qv bz-qv--loading"><div class="bz-qv__gallery"><div class="bz-skeleton" style="aspect-ratio:4/5"></div></div>' +
      '<div class="bz-qv__info"><div class="bz-skeleton" style="height:3.2rem;width:70%"></div>' +
      '<div class="bz-skeleton" style="height:2rem;width:30%;margin-top:1.6rem"></div>' +
      '<div class="bz-skeleton" style="height:9rem;margin-top:2.4rem"></div>' +
      '<div class="bz-skeleton" style="height:5.2rem;margin-top:2.4rem"></div></div></div>'
    );
  }

  function fetchSection(url) {
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    return fetch(url, { credentials: 'same-origin' })
      .then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('.bz-qv');
        const out = el ? el.outerHTML : '';
        cache.set(url, out);
        return out;
      });
  }

  function sectionUrl(productUrl, variantId) {
    const u = new URL(productUrl, window.location.origin);
    u.searchParams.set('section_id', 'bz-quick-view');
    if (variantId) u.searchParams.set('variant', variantId);
    return u.pathname + u.search;
  }

  function open(productUrl, trigger) {
    if (!modal) buildModal();
    body.innerHTML = skeleton();
    window.BZ ? window.BZ.openDrawer(modal) : modal.setAttribute('open', '');
    fetchSection(sectionUrl(productUrl))
      .then((html) => {
        if (!html) throw new Error('empty');
        body.innerHTML = html;
        init(body.querySelector('.bz-qv'));
        if (window.BZ) window.BZ.init(body);
        const first = body.querySelector('.bz-qv__title a');
        if (first) first.focus({ preventScroll: true });
      })
      .catch(() => {
        window.location.href = productUrl;
      });
    modal.dataset.trigger = trigger ? '1' : '';
  }

  function init(root) {
    if (!root) return;
    const jsonEl = root.querySelector('[data-bz-qv-json]');
    const data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    const form = root.querySelector('[data-bz-qv-form]');
    const idInput = form.querySelector('[name="id"]');
    const addBtn = form.querySelector('[data-bz-qv-add]');
    const stock = form.querySelector('[data-bz-qv-stock]');
    const errorEl = form.querySelector('[data-bz-qv-error]');
    const stage = root.querySelector('.bz-qv__stage');
    const thumbs = root.querySelectorAll('.bz-qv__thumb');
    const productUrl = root.dataset.productUrl;

    /* Gallery */
    function goTo(index) {
      const slide = stage.children[index];
      if (!slide) return;
      stage.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    }
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.index))));
    if (stage && thumbs.length) {
      let raf;
      stage.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(stage.scrollLeft / stage.clientWidth);
            thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
          });
        },
        { passive: true }
      );
    }

    /* Quantity */
    form.querySelectorAll('[data-bz-qty]').forEach((btn) =>
      btn.addEventListener('click', () => {
        const q = form.querySelector('[name="quantity"]');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(btn.dataset.bzQty));
      })
    );

    /* Variants */
    function selectedOptions() {
      const out = [];
      form.querySelectorAll('input[type="radio"]:checked').forEach((r) => (out[Number(r.dataset.optionIndex)] = r.value));
      return out;
    }
    function setButton(variant) {
      const label = addBtn.querySelector('span');
      if (!variant) {
        addBtn.disabled = true;
        label.textContent = addBtn.dataset.labelUnavailable;
      } else if (!variant.available) {
        addBtn.disabled = true;
        label.textContent = addBtn.dataset.labelSold;
      } else {
        addBtn.disabled = false;
        label.textContent = addBtn.dataset.labelAdd;
      }
      if (stock) {
        const ok = variant && variant.available;
        stock.innerHTML = `<span class="bz-stock${ok ? '' : ' bz-stock--out'}">${ok ? stock.dataset.labelIn : stock.dataset.labelOut}</span>`;
      }
    }
    form.addEventListener('change', (e) => {
      if (e.target.type !== 'radio') return;
      const opts = selectedOptions();
      const label = form.querySelector(`[data-bz-qv-selected="${e.target.dataset.optionIndex}"]`);
      if (label) label.textContent = e.target.value;
      const variant = data.variants.find((v) => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));
      setButton(variant);
      if (!variant) return;
      idInput.value = variant.id;
      if (variant.media_id) {
        const slide = stage.querySelector(`[data-media-id="${variant.media_id}"]`);
        if (slide) goTo([...stage.children].indexOf(slide));
      }
      fetchSection(sectionUrl(productUrl, variant.id)).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const price = doc.querySelector('[data-bz-qv-price]');
        const target = root.querySelector('[data-bz-qv-price]');
        if (price && target) target.innerHTML = price.innerHTML;
      });
    });

    /* Add to cart — mirrors Dawn's product-form.js so cart drawer/notification update natively */
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;
      errorEl.hidden = true;
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const fd = new FormData();
      fd.append('id', idInput.value);
      fd.append('quantity', form.querySelector('[name="quantity"]').value || 1);
      if (cart && cart.getSectionsToRender) {
        fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
        fd.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }

      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            errorEl.textContent = response.description || response.message;
            errorEl.hidden = false;
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bz-quick-view', productVariantId: idInput.value, cartData: response });
          }
          window.BZ ? window.BZ.closeDrawer(modal) : modal.removeAttribute('open');
          if (cart && cart.renderContents) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            setTimeout(() => cart.renderContents(response), 250);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => {
          errorEl.textContent = window.cartStrings ? window.cartStrings.error : 'Error';
          errorEl.hidden = false;
        })
        .finally(() => {
          addBtn.classList.remove('is-loading');
          addBtn.removeAttribute('aria-busy');
        });
    });
  }

  /* Direct add (single-variant "+" on compact cards) — same cart contract as Dawn's product-form.js */
  function directAdd(btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const fd = new FormData();
    fd.append('id', btn.dataset.variantId);
    fd.append('quantity', 1);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          if (window.BZ) window.BZ.toast(response.description || response.message);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bz-quick-add', productVariantId: btn.dataset.variantId, cartData: response });
        }
        if (cart && cart.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
      })
      .catch(() => window.BZ && window.cartStrings && window.BZ.toast(window.cartStrings.error))
      .finally(() => {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-bz-quick-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      directAdd(add);
      return;
    }
    const btn = e.target.closest('[data-bz-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.dataset.bzQuickView, btn);
  });

  /* Warm the cache on hover (desktop) for instant opening */
  document.addEventListener(
    'pointerenter',
    (e) => {
      if (e.pointerType !== 'mouse' || !e.target.closest) return;
      const btn = e.target.closest('[data-bz-quick-view]');
      if (btn) fetchSection(sectionUrl(btn.dataset.bzQuickView)).catch(() => {});
    },
    true
  );

  window.BZQuickView = { open };
})();
